import React from "react";
import { RecentPracticeCardProps, RecentPracticeCard } from "./RecentPracticeCard";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../../utils/contexts/UserProvider";
import { useResource } from "../../../services";
import { ParticipantExam } from "../../../types/components";
import { formatDateWithTime } from "../../../utils/date";
import { NoExams } from "../../molecules/exam/NoExams";
import { SectionSeparator } from "../../atom/SectionSeparator";
import { createResourceUrl } from "../../../utils/data";

export const RecentPracticeExams: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useUserContext();
  const { data } = useResource<ParticipantExam[]>(
    createResourceUrl("/common/participant-exam", {
      include: ["exam", "exam.exam_type"],
      filters: {
        "eq:participant_id": user?.id,
        "in:exam.exam_type.code": "practice_small,practice_big",
      },
      sort: "-created_at",
      per_page: 9999,
    }),
    user,
  );

  const recentExamsArr = !data
    ? []
    : data?.map(({ exam, total_score, is_passed, created_at }): RecentPracticeCardProps => {
        const { code, exam_type } = exam;
        const { number_of_questions } = exam_type;

        return {
          title: code,
          type: t("Practice"),
          date: formatDateWithTime(created_at),
          score: `${total_score ?? 0} / ${number_of_questions ?? 0}`,
          isPassed: !!is_passed,
        };
      });

  const noExams = !recentExamsArr?.[0];

  return (
    <div className="px-[52px] mt-14 pb-10 flex flex-col gap-14">
      <SectionSeparator label={t("Recent practice exams")} type="secondary" />

      <div className={`grid gap-10 ${noExams ? "grid-cols-1" : "grid-cols-3"}`}>
        {noExams && <NoExams label="No recent practice exams." />}
        {recentExamsArr.map(({ title, type, date, score, isPassed }, index) => (
          <RecentPracticeCard
            key={index}
            title={title}
            type={type}
            score={score}
            isPassed={isPassed}
            date={date}
          />
        ))}
      </div>
    </div>
  );
};
